import { ExpenseType } from "./expense-type";
import { Axis } from "../components/home/expense/expense.component";

export class Expense {
    id:number = 0; 
    name:string = "";
    price:number = 0;
    expense_type_id:number = 0;
    expense_type:ExpenseType = new ExpenseType();
    active: boolean = true;
    axis:Axis[] = [];
}
